import React, { useState, useEffect, useRef } from "react";
import "../styles/searchDropdown.css";
import ProductCard from "./ProductCard";
import { useMediaQuery } from "react-responsive";
import useSearch from "../Hooks/useSearch";
import { Link, Navigate, useNavigate } from "react-router-dom";

const SearchDropdown = ({ onSearch }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [autocompleteText, setAutocompleteText] = useState("");
  const [isShow, setIsShow] = useState(true);
  const dropdownRef = useRef(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { search, loading, error } = useSearch();

  const debounceTimeout = useRef(null); 

  const handleInputChange = async (e) => {
    const typedText = e.target.value;
    setSearchTerm(typedText);
    setShowDropdown(true);
    setIsShow(true);

    if (typedText) {
      clearTimeout(debounceTimeout.current); 

      debounceTimeout.current = setTimeout(async () => {
        const data = await search(typedText);
        
        if (data) {
          setSuggestions(data.suggestions);
          setCategories(data.categories);
          setProducts(data.items);
          setTotalItems(data.totalItems);

          if (data?.suggestions?.length > 0) {
            const firstSuggestion = data.suggestions[0];
            if (firstSuggestion.name.toLowerCase().startsWith(typedText.toLowerCase())) {
              setAutocompleteText(firstSuggestion.name.slice(typedText.length));
            } else {
              setAutocompleteText("");
            }
          } else {
            setAutocompleteText("");
          }
        }
      }, 500); 
    } else {
      setAutocompleteText("");
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchTerm(suggestion);
    setShowDropdown(false);
    setAutocompleteText("");
    onSearch(suggestion);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      setIsShow(false);
      if (searchTerm.length > 2) {
        navigate(`/search-details/${searchTerm}`);
      }
    }
  };

  return (
    <div ref={dropdownRef} className="relative w-full searchDropdownMain ">
         <div className="relative w-full">
        <input
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          placeholder="Search products..."
          className="w-[85%] p-2 border border-gray-300 rounded-md focus:outline-none  focus:ring-black"
        />
        {autocompleteText && (
          <span className="absolute top-1/2 flex left-0 ml-2 transform -translate-y-1/2 text-black pointer-events-none">
            <div className="text-black opacity-0">{searchTerm}</div>
            <span className="text-gray-500">{autocompleteText}</span>
          </span>
        )}
      </div>

      {showDropdown && (
        //Handle here
        <div className={`absolute left-0 w-full mt-2 bg-white shadow-xl border border-gray-300 max-h-1/2 overflow-y-auto z-10 ${!isShow?"hidden":""} `}>
          <div className="flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x divide-gray-200  ">
            {/* Suggestions Section */}
            <div className="p-4 w-full md:w-1/3">
              <h4 className="dropdownlabel">Suggestions for You</h4>
              <ul className="space-y-2 md:mb-4 mb-3">

                {suggestions?.slice(0, 6).map((suggestion, index) => (
                  <Link to={suggestion.link}>
                  <li
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion.name)}
                    className="dropdownSuggestions"
                    style={{ wordWrap: "break-word" }}
                  >
                   
                    <span className="mr-2">
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </span>{" "}
                    <p className="text-ellipsis overflow-hidden">
                      {suggestion.name}
                    </p>
                  </li>
                  </Link>
                ))}
              </ul>
              <h4 className="dropdownlabel">Categories</h4>
              <ul className="space-y-2 mt-2">
                {categories?.slice(0, 1).map((category) => (
                  <li
                    key={category.category_id}
                    className="cursor-pointer hover:bg-gray-100 p-0 rounded-md"
                  >
                    <a
                      href={category.link}
                      className="flex items-center p-0 m-0"
                    >
                      <span className="dropdownSuggestions p-0">
                        {category.title}
                      </span>
                    </a>
                  </li>
                ))}
                {/* <li className="cursor-pointer hover:bg-gray-100 p-0 rounded-md mt-0">
                  <a href="collections" className="flex items-center p-0 m-0">
                    <span className="dropdownSuggestions p-0">More</span>
                    <span className="ms-2">➔</span>
                  </a>
                </li> */}
              </ul>
              {/* {!isMobile && (
                <button className="w-full py-3 bg-gray-800 text-white font-medium text-center hover:bg-gray-700 transition mt-2">
                  View All {totalItems} Items ➔
                </button>
              )} */}
            </div>

            {/* Products Section */}
            <div className="p-4 w-full md:w-2/3">
              <h4 className="dropdownlabel">Products</h4>
              <div className="grid grid-cols-3 gap-4" onClick={()=>setShowDropdown(false)}>
                {products?.map((product) => (
                  <ProductCard
                    key={product.product_id}
                    height={250}
                    name={product.title}
                    description={product.description}
                    price={product.price}
                    image={product.image_link}
                    navigateLink={`/product/${product.product_id}`}
                  />
                ))}
              </div>
            </div>
          </div>
          {/* {isMobile && (
            <button className="w-full py-3 bg-gray-800 text-white font-medium text-center hover:bg-gray-700 transition mt-2 rounded-b-lg">
              View All {totalItems} Items ➔
            </button>
          )} */}
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
